import { ticketLinkTypes } from '../../../../common/constants/ticketLinkTypes';

/**
 * [formatSendTemplate description]
 * @param  {object} templateData template object from the template_form
 * @param  {object} mode Editing or no
 * @return {object} mode that is formatted for the api call
 */
export const formatSendTemplate = (templateData, mode) => {
  const formattedTemplate = {};
  const problematicOffersList = { errors: [] };
  const { templateZones, zoneIds, canNotBePublished } = getZoneAndOfferIds(
    templateData.linkedZones
  );
  const { eventId, templateName } = templateData;
  const seasonIds = templateData.seasonCategory.map((item) => item.value);
  const catIds = templateData.eventCategory.map((item) => item.value);
  const categoryIds = catIds.concat(seasonIds);
  problematicOffersList.errors = canNotBePublished;
  const templateId = mode === 'edit' ? templateData.templateId : null;
  return canNotBePublished.length > 0
    ? problematicOffersList
    : Object.assign(formattedTemplate, {
        eventId,
        templateId,
        templateName,
        categoryIds,
        templateZones,
        zoneIds,
      });
};

/**
 * getZoneAndOfferIds gathers offerIds, zoneIds, and templateZone data
 * @param  {[array]} zoneArr array of linked zones from the template
 * @return {[object]} an object with zoneIds, and templateZones and offer ticket template link type
 */
const getZoneAndOfferIds = (zoneArr) => {
  const result = {};
  result.templateZones = [];
  result.zoneIds = [];
  result.canNotBePublished = [];
  zoneArr.forEach((zone) => {
    result.zoneIds.push(zone.id);
    const zoneObj = {
      Id: zone.id,
      Offers: [],
    };
    zone.offers.forEach((offer) => {
      const AXSPromotion = {};
      const axsPromotion = offer.axsPromotion;
      if (
        axsPromotion &&
        Number(axsPromotion.ticketLinkType) ===
          Number(ticketLinkTypes.SEPARATE_PROMOTION)
      ) {
        AXSPromotion.TicketLinkType = axsPromotion.ticketLinkType;
        AXSPromotion.PromotionName = axsPromotion.promoName;
        AXSPromotion.PromotionShortDescription =
          axsPromotion.promoShortDescription;
        AXSPromotion.PromotionDescription = axsPromotion.promoDescription;
        AXSPromotion.GroupId = axsPromotion.promoGroup;
        AXSPromotion.TemplateId = axsPromotion.promoTemplate;
        AXSPromotion.Status = axsPromotion.status;
        AXSPromotion.VisibleStartDate = axsPromotion.visibleStartDate;
        AXSPromotion.VisibleEndDate = axsPromotion.visibleEndDate;

        const DisplayListArray = axsPromotion.display === 'Private' ? 1 : 2;
        AXSPromotion.DisplayListArray = [DisplayListArray];
      } else if (
        axsPromotion &&
        Number(axsPromotion.ticketLinkType) !==
          Number(ticketLinkTypes.SEPARATE_PROMOTION)
      ) {
        AXSPromotion.TicketLinkType = axsPromotion.ticketLinkType;
      }

      const offerData = {
        Id: offer.id,
        AXSPromotion,
        isAutoPublish: offer.isAutoPublish ? offer.isAutoPublish : false,
        canBeAutoPublished: offer.canBeAutoPublished
          ? offer.canBeAutoPublished
          : false,
      };
      // send empty AXSPromotion object if not CMS data / not a web offer
      offerData.Groups = [];
      offer.groups.forEach((group) => {
        offerData.Groups.push({
          Id: group.id,
          TemplateOfferGroupId: group.templateOfferGroupId,
        });
      });
      if (offerData.isAutoPublish && !offerData.canBeAutoPublished) {
        result.canNotBePublished.push(offer);
      }

      zoneObj.Offers.push(offerData);
    });

    result.templateZones.push(zoneObj);
  });
  return result;
};

/**
 * Determines if offer has a web outlet enabled - which determines if we show the CMS portion of edit template offer
 * @param {object} offer
 * @returns {boolean} if offer has a web outlet enabled
 */
export const hasWebOutlet = (offer) => {
  let result = false;
  offer &&
    offer.outlets.forEach((outlet) => {
      if (outlet.type.toLowerCase() === 'web') {
        result = true;
      }
    });
  return result;
};

export const formatEventsCategory = (categories) => {
  const filteredEventCategory = categories.filter(
    (category) => category.typeId === 2
  );
  return filteredEventCategory.length > 0
    ? filteredEventCategory.map((item) => ({
        key: item.id,
        text: item.name,
        value: item.id,
      }))
    : [];
};

export const formatSeasonsCategory = (categories) => {
  const filteredSeasonCategory = categories.filter(
    (category) => category.typeId === 1
  );
  return filteredSeasonCategory.length > 0
    ? filteredSeasonCategory.map((item) => ({
        key: item.id,
        text: item.name,
        value: item.id,
      }))
    : [];
};

export const getIsPublicEDP = (isNewEvent, siteData) => {
  siteData = siteData ? siteData : {};
  // EDP Status is determined by presence of Site Id 999. If there, it's public,
  // otherwise it is private.
  return isNewEvent || Object.keys(siteData).includes('999');
};

/**
 * indexOfObjects receives array of objects and id as an arguments. It should return index of founded element with given lookupId
 * @param  {[array]} objectsArr array of linked zones from the template
 * @param {number} lookupId  an id of remaining template zone
 * @return {number} index of founded zone;
 */

export const indexOfObjects = (objectsArr, lookupId) => {
  let result = -1;
  for (let i = 0; i < objectsArr.length; i++) {
    if (objectsArr[i].id == lookupId) {
      result = i;
      break;
    }
  }
  return result;
};

const findAlreadyAddedOffers = (oldOffers, newOffers) => {
  for (let i = 0; i < oldOffers.length; i++) {
    for (let j = 0; j < newOffers.length; j++) {
      if (oldOffers[i].lookupId === newOffers[j].lookupId) {
        newOffers.splice(j, 1);
      }
    }
  }
  return newOffers;
};

export const filterOnlyNews = (oldOffers, newOffers) => {
  return findAlreadyAddedOffers(oldOffers, newOffers);
};

export const mergeTwoObject = (first, second) => {
  return Object.assign({}, first, { offers: second });
};

export const getZonesWithDeletedOffers = (linkedZones) => {
  let result = [];
  linkedZones.forEach((zone) => {
    zone.deletedLocally && result.push(...zone.deletedLocally);
  });
  return result;
};

export const mergeZoneOffers = (remainingZones, linkedZones) => {
  remainingZones.forEach((rem) => {
    let indexOfZone = indexOfObjects(linkedZones, rem.id);
    if (indexOfZone !== -1) {
      linkedZones[indexOfZone].deletedLocally = [];
      let linkedOffers = linkedZones[indexOfZone].offers;
      linkedZones[indexOfZone].offers = linkedOffers.concat(
        filterOnlyNews(
          linkedOffers,
          rem.offers.length > 0 ? rem.offers : [rem.offers]
        )
      );
    } else {
      linkedZones.push(rem);
    }
  });
  return linkedZones;
};
export const errorMessageForTemplateName = (isEmpty, hasWhiteSpace) =>
  isEmpty
    ? 'This field is required!'
    : hasWhiteSpace
    ? 'Name must not contain only white spaces! Please change the name'
    : '';



// WEBPACK FOOTER //
// ./src/routes/Templates/common/helpers/index.js